import { useEffect, useState } from 'react';
import type { ReconnectEpisode } from 'hooks/useRecordingWebSocket';
import { RECONNECT_BUDGET_MS } from 'hooks/useRecordingReconnect';

const SHOW_AFTER_SECONDS = 30;
const SHOW_UNTIL_SECONDS = RECONNECT_BUDGET_MS / 1000;

export interface ReconnectBanner {
  seconds: number;
  reasonCode: string;
}

export function useReconnectBanner(episode: ReconnectEpisode | null): ReconnectBanner | null {
  const [visibleSeconds, setVisibleSeconds] = useState<number | null>(null);
  const startedAt = episode?.startedAt ?? null;

  useEffect(() => {
    if (startedAt === null) {
      setVisibleSeconds(null);
      return;
    }

    const tick = () => {
      const elapsed = Math.floor((Date.now() - startedAt) / 1000);
      const withinWindow = elapsed >= SHOW_AFTER_SECONDS && elapsed < SHOW_UNTIL_SECONDS;
      setVisibleSeconds(withinWindow ? elapsed : null);
    };
    tick();
    const intervalId = setInterval(tick, 1000);

    return () => clearInterval(intervalId);
  }, [startedAt]);

  if (episode === null || visibleSeconds === null) return null;

  return { seconds: visibleSeconds, reasonCode: episode.reasonCode };
}
